import React, { forwardRef } from 'react';
import { createStyles } from '@mantine/core';

import { VectorGuaranteedPlusIcon } from '~/domains/design-system/vectors/VectorGuaranteedPlusIcon';
import dt from '~/testing';

interface GuaranteedPlusBadgeProps {
  size?: 'micro' | 'xsmall' | 'small' | 'medium' | 'large';
  width?: number;
  height?: number;
  className?: string;
  dataTestId?: string;
  style?: React.CSSProperties;
}

const ICON_SIZES = {
  micro: 16,
  xsmall: 24,
  small: 32,
  medium: 48,
  large: 64,
};

const useStyles = createStyles({
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
  },
});

const GuaranteedPlusBadge = forwardRef<HTMLDivElement, GuaranteedPlusBadgeProps>(
  (
    {
      size = 'medium',
      width,
      height,
      className,
      dataTestId = dt.designSystem.badges.guaranteedPlusBadge,
      style,
      ...props
    },
    ref
  ) => {
    const { classes, cx } = useStyles();
    const iconSize = width || height || ICON_SIZES[size];

    return (
      <div
        ref={ref}
        className={cx(classes.badge, className)}
        data-test-id={dataTestId}
        style={style}
        {...props}
      >
        <VectorGuaranteedPlusIcon height={iconSize} />
      </div>
    );
  }
);

GuaranteedPlusBadge.displayName = 'GuaranteedPlusBadge';

export default GuaranteedPlusBadge;
